import Aos from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useMemo, useState } from "react";
import Volunteer from "../volunteer/Volunteer";
import { server } from "../../common"; // axios instance
import { toast } from "react-toastify";
import "../../index.css"

const About = () => {
  const [vmData, setVmData] = useState({ vision: null, mission: null });
  const [aboutItem, setAboutItem] = useState(null);
  const [chairItem, setChairItem] = useState(null);
  const [loading, setLoading] = useState({
    vm: false,
    about: false,
    chair: false,
  });

  useEffect(() => {
    Aos.init({ duration: 2000, disable: "mobile" });
  }, []);

  // Vision & Mission
  useEffect(() => {
    setLoading((s) => ({ ...s, vm: true }));
    server
      .get("/gallery/getvisionmission")
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        const vision = list.find((x) => x.type === "vision") || null;
        const mission = list.find((x) => x.type === "mission") || null;
        setVmData({ vision, mission });
      })
      .catch(() => {
        toast.error("Failed to load Vision & Mission");
      })
      .finally(() => setLoading((s) => ({ ...s, vm: false })));
  }, []);

  // About Us (only image + description)
  useEffect(() => {
    setLoading((s) => ({ ...s, about: true }));
    server
      .get("/about/getallabout")
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        // Using the latest entry (already DESC). If you want the first ever, use list[list.length-1]
        const item = list[0] || null;
        setAboutItem(
          item
            ? {
                image: item.image || "/images/aboutus.jpg",
                description:
                  item.description ||
                  "About Us content will appear here once available.",
              }
            : null
        );
      })
      .catch(() => {
        toast.error("Failed to load About Us");
      })
      .finally(() => setLoading((s) => ({ ...s, about: false })));
  }, []);

  // Chairwoman (only image + description)
  useEffect(() => {
    setLoading((s) => ({ ...s, chair: true }));
    server
      .get("/chairwoman/getallchairwoman")
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        const item = list[0] || null;
        setChairItem(
          item
            ? {
                image: item.image || "/images/chair.png",
                description:
                  item.description ||
                  "Chairwoman's message will appear here once available.",
              }
            : null
        );
      })
      .catch(() => {
        toast.error("Failed to load Chairwoman's Message");
      })
      .finally(() => setLoading((s) => ({ ...s, chair: false })));
  }, []);

  const visionDesc = useMemo(
    () =>
      vmData.vision?.description ||
      "Our vision content will appear here once available.",
    [vmData.vision]
  );

  const visionImg = useMemo(
    () => vmData.vision?.image || "/images/s.jpeg",
    [vmData.vision]
  );

  const missionDesc = useMemo(
    () =>
      vmData.mission?.description ||
      "Our mission content will appear here once available.",
    [vmData.mission]
  );

  const missionImg = useMemo(
    () => vmData.mission?.image || "/images/s1.jpeg",
    [vmData.mission]
  );

  return (
    <>
      {/* <!-- ============abt-01 Section  Start============ --> */}
      <section className="abt-01">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading-wrapper">
                <h3>About Us</h3>
                <ol>
                  <li>
                    Home<i className="fa fa-angle-double-right"></i>
                  </li>
                  <li>About Us</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- =========================================ABOUT US>>>START========================================= --> */}
      <section className="my-5">
        <div className="container">
          {/* About intro */}
          <div className="row">
            <div className="col-12">
              <div className="heading my-1">
                <h2>ABOUT US</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-7 col-12">
              <div className="_lk_fr_er">
                <p style={{ textAlign: "justify" }} data-aos="fade-right">
                  {aboutItem?.description ||
                    (loading.about
                      ? "Loading About Us..."
                      : "Welcome to the Venkateshwara Welfare Foundation, dedicated to uplifting farmers and agricultural communities worldwide.")}
                </p>
              </div>
            </div>

            <div
              className="col-lg-5 col-12 align-self-center"
              data-aos="fade-left"
            >
              <img
                src={aboutItem?.image || "/images/aboutus.jpg"}
                alt="About Us"
                className="img-fluid"
              />
            </div>
          </div>

          {/* Chairwoman's message */}
          <div className="row">
            <div className="col-12">
              <div className="heading my-5">
                <h2>Chairwoman's Message</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 text-center" data-aos="fade-right">
              <img
                src={chairItem?.image || "/images/chair.png"}
                className="img-fluid"
                alt="Chairwoman"
              />
            </div>
            <div
              className="col-md-6 mt-3"
              style={{ textAlign: "justify" }}
              data-aos="fade-left"
            >
              <p>
                {chairItem?.description ||
                  (loading.chair
                    ? "Loading Chairwoman's Message..."
                    : "Our foundation is dedicated to empowering and uplifting farmers across the country...")}
              </p>
              <br />
              <b>Mukta Shivaji Dole</b>
              <p>Chairwoman, Venkateshwara Farmers Welfare Foundation</p>
            </div>
          </div>

          {/* Vision */}
          <div className="container py-4 mt-4">
            <div className="row">
              <div className="col-md-6">
                <h3>Vision</h3>
                <p style={{ textAlign: "justify" }} data-aos="fade-right">
                  {visionDesc}
                </p>
              </div>
              <div
                className="col-md-6 text-center align-self-center"
                data-aos="fade-left"
              >
                <img src={visionImg} className="img-fluid" alt="Vision" />
              </div>
            </div>

            {/* Mission */}
            <div className="row mt-4">
              <div
                className="col-md-6  text-center align-self-center"
                data-aos="fade-right"
              >
                <img src={missionImg} className="img-fluid" alt="Mission" />
              </div>
              <div className="col-md-6" data-aos="fade-left">
                <h3>Mission</h3>
                <p style={{ textAlign: "justify" }}>{missionDesc}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Volunteer />
    </>
  );
};

export default About;
